<!-- TODO need optimization for clean group -->
<template>
  <div class="filter">
    <FormGenerator
      :data="data"
      :withGroups="withGroups"
      :isLoading="isLoading"
      :showFormControls="false"
      @updateItem="setFilter"
      @input="inputFormField"
      @submit="submitFormGenerator"
      ref="formGenerator"
    >
      <template
        v-for="(index, slotName) in $scopedSlots"
        v-slot:[slotName]="slotData"
      >
        <slot :name="slotName" :data="slotData"></slot>
      </template>
    </FormGenerator>
    <div class="filter__list-selected" v-if="isSelectedFilters">
      <div class="filter__label">Filters:</div>
      <div
        class="filter__item-selected"
        v-for="(filter, key) in selectedFilters"
        :key="key"
      >
        <div class="filter__item-label-selected">{{ filter.label }}:</div>

        <template v-if="Array.isArray(filter.value)">
          <div
            v-if="filter.type === 'range_slider'"
            class="filter__item-value-selected"
            @click="removeFilter(key, null, filter.group)"
          >
            {{ getRangeValueBySelect(filter) }}
            <span class="material-icons icon-image-preview"> close </span>
          </div>
          <div
            v-else
            class="filter__item-value-selected"
            v-for="(value, index) in filter.value"
            :key="index"
            @click="removeFilter(key, index, filter.group)"
          >
            <template v-if="filter.type !== 'datepicker'">
              <span v-if="isHomePage && filter.type === 'slot'"
                >{{ value.name }} <span class="material-icons star">star</span
                >{{ value.value }}</span
              >
              <span v-else>
                {{ value[filter.selectLabel] || value }}
              </span>
            </template>
            <span class="material-icons icon-image-preview"> close </span>
          </div>
        </template>

        <template v-else>
          <div
            class="filter__item-value-selected"
            @click="removeFilter(key, null, filter.group)"
          >
            <template v-if="filter.type === 'datepicker'">
              {{ _toLocalTime(filter.value, "DD/MM/YYYY") }}
            </template>
            <template v-if="filter.type === 'input'">
              {{ filter.value }}
            </template>
            <template v-if="filter.type === 'range'">
              {{ filter.value }}
            </template>
            <template v-if="filter.type === 'select'">
              {{ getValueBySelect(filter) }}
            </template>
            <span class="material-icons icon-image-preview"> close </span>
          </div>
        </template>
      </div>
    </div>
    <div class="filter__footer">
      <b-button
        class="button filter__footer-item"
        @click="clearCache"
        variant="outline"
        v-if="showClearCache"
      >
        <span class="material-icons icon-image-preview"> clear_all </span>
        Clear cache
      </b-button>
      <b-button
        class="button reset-button filter__footer-item mr-2"
        :disabled="isLoading"
        @click="resetFilter"
      >
        Reset
      </b-button>
      <b-button
        class="button filter__footer-item"
        variant="primary"
        :disabled="isLoading || disableSubmit"
        @click="submit"
      >
        <Preloader v-if="isLoading && usePreloaderOverlay" customClasses="button-preloader" />
        <div v-if="isLoading" class="spinner-border button-spinner" role="status"></div>
        {{ isLoading ? "LOADING..." : textButtonSubmit }}
      </b-button>
    </div>
  </div>
</template>

<script>
import FormGenerator from '@components/FormGenerator'
import Preloader from '@components/Preloader'

export default {
  components: {
    FormGenerator,
    Preloader
  },
  data () {
    return {
      selectedFilters: {}
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    withGroups: {
      type: Boolean,
      default: false
    },
    resetToInitial: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    textButtonSubmit: {
      type: String,
      default: 'Submit'
    },
    showClearCache: {
      type: Boolean,
      default: false
    },
    dataChanges: {
      type: Boolean,
      default: false
    },
    disableSubmit: {
      type: Boolean,
      default: false
    },
    usePreloaderOverlay: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isSelectedFilters () {
      return Object.values(this.selectedFilters).length
    },
    isHomePage () {
      return this.$route.path === '/'
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler () {
        if (this.withGroups) {
          for (let groupName in this.data.groups) {
            for (let key in this.data.groups[groupName].fields) {
              this.setFilter(key, this.data.groups[groupName].fields[key])
            }
          }
        } else {
          for (let key in this.data) {
            this.setFilter(key, this.data[key])
          }
        }
      }
    }
  },
  methods: {
    clearCache () {
      this.$emit('clearCache')
    },
    getRangeValueBySelect (field) {
      if (!field.value || !Array.isArray(field.value) || field.value.length < 2) {
        return null
      }

      const fromItem = field.value[0]
      const toItem = field.value[1]

      if (!fromItem || !toItem) {
        return null
      }

      const fromValue = (typeof fromItem === 'object' && field.labelField)
        ? fromItem[field.labelField]
        : fromItem
      const toValue = (typeof toItem === 'object' && field.labelField)
        ? toItem[field.labelField]
        : toItem

      return fromValue && toValue ? `${fromValue} - ${toValue}` : null
    },
    getValueBySelect (field) {
      const currentField = field.options.find((item) => {
        const itemValue = item[field.valueField] || item
        const fieldValue = field.value[field.valueField] || field.value

        return itemValue === fieldValue
      })

      if (!currentField) return null

      return field.selectLabel ? currentField[field.selectLabel] : currentField
    },
    submit () {
      this.$refs['formGenerator'].submit()
    },
    submitFormGenerator () {
      this.$emit('submit', this.selectedFilters)
    },
    removeFilter (key, index, filterGroup) {
      this.$refs['formGenerator'].cleanField(key, index, filterGroup)
    },
    resetFilter () {
      if (this.withGroups) {
        this.resetToInitial
          ? this.$refs['formGenerator'].setInitialFormWithGroups()
          : this.$refs['formGenerator'].cleanFormWithGroups()
      } else {
        this.resetToInitial
          ? this.$refs['formGenerator'].setInitialForm()
          : this.$refs['formGenerator'].cleanForm()
      }

      if (this.resetToInitial) {
        Object.keys(this.data).forEach((key) => {
          const defaultValue = this.data[key]?.defaultValue
          if (defaultValue !== undefined && defaultValue !== null) {
            if (!this.selectedFilters[key]) {
              this.$set(this.selectedFilters, key, {})
            }
            this.selectedFilters[key].value = defaultValue
          } else {
            this.$delete(this.selectedFilters, key)
          }
        })

        if (this.data.groups) {
          Object.keys(this.data.groups).forEach((groupKey) => {
            Object.keys(this.data.groups[groupKey].fields).forEach(
              (fieldKey) => {
                const field = this.data.groups[groupKey].fields[fieldKey]
                const defaultValue = field?.defaultValue
                field.value =
                  defaultValue !== undefined
                    ? defaultValue
                    : Array.isArray(field.value) &&
                      field.type !== 'range_slider'
                      ? []
                      : null
              }
            )
          })
        }
      } else {
        this.selectedFilters = {}
      }

      if (this.dataChanges && this.resetToInitial) {
        Object.keys(this.data).forEach((key) => {
          const defaultValue = this.data[key]?.defaultValue
          this.data[key].value =
            defaultValue !== undefined
              ? defaultValue
              : Array.isArray(this.data[key].value) &&
                this.data[key].type !== 'range_slider'
                ? []
                : null
        })

        if (this.data.groups) {
          Object.keys(this.data.groups).forEach((groupKey) => {
            Object.keys(this.data.groups[groupKey].fields).forEach(
              (fieldKey) => {
                const field = this.data.groups[groupKey].fields[fieldKey]
                const defaultValue = field?.defaultValue
                field.value =
                  defaultValue !== undefined
                    ? defaultValue
                    : Array.isArray(field.value) &&
                      field.type !== 'range_slider'
                      ? []
                      : null
              }
            )
          })
        }

        this.$emit('changes', this.data)
      }

      this.$emit('reset', this.selectedFilters)
    },
    setFilter (key, itemData) {
      // range slider can't have a null value, so the value will be the default value instead
      if (itemData.type === 'range_slider' && !itemData.value) {
        itemData.value = itemData.data
          ? [itemData.data[0], itemData.data[itemData.data.length - 1]]
          : [itemData.min || 1, itemData.max || 10]
      }

      const isNumber = typeof itemData.value === 'number'
      const isBoolean = typeof itemData.value === 'boolean'
      const isValueByObject =
        itemData.value &&
        typeof itemData.value === 'object' &&
        !Array.isArray(itemData.value)
      const isValueByArray = itemData.value && itemData.value.length

      if (isValueByObject || isValueByArray || isNumber || isBoolean) {
        this.selectedFilters = {
          ...this.selectedFilters,
          [key]: itemData
        }
        if (!itemData.value) {
          delete this.selectedFilters[key]
        }

        setTimeout(() => {
          for (const key in this.selectedFilters) {
            if (this.selectedFilters[key].hidden) {
              this.selectedFilters[key].value = []
              delete this.selectedFilters[key]
            }
          }
        }, 10)
        return
      }

      if (this.selectedFilters[key]) {
        const newFilter = this._removeProperty(key)
        this.selectedFilters = newFilter(this.selectedFilters)
      }
    },
    inputFormField (fields) {
      if (this.dataChanges) {
        this.$emit('changes', fields)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.star {
  font-size: 14px;
  color: $fontColorAccent !important;
  position: relative;
  top: 2px;
  width: auto;
  height: auto;
  margin-left: 0 !important;
}

.filter__footer-item {
  margin-right: 15px;
  &:last-child {
    margin-right: 0;
  }
}
.filter__footer {
  padding: 15px 0;
  margin-bottom: -15px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #cacae1;
}
.filter__label {
  font-size: 12px;
  line-height: 30px;
  color: #3d5170;
  margin-right: 10px;
}
.filter__list-selected {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.filter__item-selected {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.filter__item-value-selected {
  font-size: 12px;
  line-height: 30px;
  margin-right: 5px;
  color: $fontColorAccent;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover,
  &:focus {
    .material-icons {
      color: $fontColorAccent;
    }
  }
  .material-icons {
    color: $fontColor2;
    margin-left: 2px;
    margin-right: 0;
  }
}
.filter__item-label-selected {
  font-size: 12px;
  line-height: 24px;
  margin-right: 5px;
  color: $fontColorBase;
}

 .button-spinner {
  width: 16px;
  height: 16px;
  background-color: transparent;
  margin-right: 4px;
  border-width: 1px;
  border-color: white white white transparent;
}

::v-deep .button-preloader .spinner-border {
  display: none;
}

</style>
